import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNohtml]',
  standalone: true
})
export class NohtmlDirective {
  constructor(
    private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    @Optional() private ngControl: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const inputElement = this.el.nativeElement;
    const originalValue = inputElement.value;

    // This regex removes anything that looks like an HTML tag.
    const sanitizedValue = originalValue.replace(/<[^>]*>/g, '');

    if (originalValue !== sanitizedValue) {
      // If the value was changed, update the element's value.
      inputElement.value = sanitizedValue;

      // If this is a form control (template-driven or reactive),
      // also update the control's value in the model.
      this.ngControl?.control?.setValue(sanitizedValue);
    }
  }}
